var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('performance-review-template-editor',{attrs:{"is-admin":_vm.loggedInEmployee.isAdmin,"is-saving":_vm.isSaving,"title":"New Template"},on:{"save":_vm.onSave,"cancel":_vm.onCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }